import { Client } from "@/types/client";

export enum MeetingPrepStatus {
  Generating = "GENERATING",
  Ready = "READY",
  Failed = "FAILED",
}

export interface MeetingPrepEntity {
  id: string;
  userId: string;
  firmId: string;
  title: string;
  agenda: string;
  pastSummaryNote: string;
  meetingId: string;
  status?: MeetingPrepStatus;
  createdAt: number;
  updatedAt: number;
  clients?: Client[];
}

export type MeetingPrepEmail = {
  id: string;
  firmId: string;
  userId: string;
  meetingId: string;
  meetingPrepId: string;
  subject: string;
  body: string;
  /**
   * Id of the template used at generation time. May reference a since-deleted
   * template — don't assume it resolves against the user's template list.
   * Null when the email was generated with the built-in default or predates
   * template tracking (FE-1097).
   */
  templateId: string | null;
  /**
   * Denormalized snapshot of the template's name at generation time —
   * survives template rename/deletion. Null whenever templateId is null.
   */
  templateName: string | null;
};
